// Обработчики каталогов ЕМИСС и World Bank и менеджера показателя ЕМИСС.

import { clearEmissInspectionState, closeEmissManager, diagnoseEmiss, inspectEmissIndicator, openEmissManager, refreshEmissCatalog, refreshEmissRequestLog, refreshLeftEmissCatalog, registerEmissIndicator, searchEmissCatalog, searchEmissFilterValues, searchLeftEmissCatalog, selectEmissCatalogItem, selectLeftEmissCatalogItem } from '../emiss';
import { controls } from '../controls';
import { refreshWorldBankCatalog, searchWorldBankCatalog, selectWorldBankCatalogItem } from '../worldbank';
import { setSourcesMenuOpen } from '../workspace';
import { state } from '../state';

export function bindSourceCatalogEvents(): void {
  controls.openEmissManager.addEventListener('click', () => {
    setSourcesMenuOpen(false);
    void openEmissManager();
  });
  controls.leftEmissOpenManager.addEventListener('click', () => void openEmissManager());
  controls.closeEmissManager.addEventListener('click', closeEmissManager);
  controls.emissDialog.addEventListener('cancel', () => {
    controls.openEmissManager.setAttribute('aria-expanded', 'false');
  });
  controls.emissDialog.addEventListener('click', (event) => {
    if (event.target === controls.emissDialog) closeEmissManager();
  });
  controls.emissDiagnostics.addEventListener('click', () => void diagnoseEmiss());
  controls.emissInspect.addEventListener('click', () => void inspectEmissIndicator());
  controls.emissRegister.addEventListener('click', () => void registerEmissIndicator());
  controls.refreshEmissLog.addEventListener('click', () => void refreshEmissRequestLog());
  controls.emissCatalogRefresh.addEventListener('click', () => void refreshEmissCatalog());
  controls.emissCatalogSearch.addEventListener('click', () => void searchEmissCatalog());
  controls.emissCatalogQuery.addEventListener('keydown', (event) => {
    if (event.key !== 'Enter') return;
    event.preventDefault();
    void searchEmissCatalog();
  });
  controls.emissCatalogIncludeExcluded.addEventListener('change', () => {
    if (controls.emissCatalogQuery.value.trim() || state.emissCatalogResults.length) void searchEmissCatalog();
  });
  controls.emissCatalogResults.addEventListener('click', (event) => {
    const button = (event.target as Element).closest<HTMLButtonElement>('[data-emiss-catalog-select]');
    const indicatorId = button?.dataset.emissCatalogSelect;
    const item = state.emissCatalogResults.find((candidate) => candidate.indicator_id === indicatorId);
    if (item) selectEmissCatalogItem(item);
  });
  controls.leftEmissCatalogRefresh.addEventListener('click', () => void refreshLeftEmissCatalog());
  controls.leftEmissCatalogSearch.addEventListener('click', () => void searchLeftEmissCatalog());
  controls.leftEmissCatalogQuery.addEventListener('keydown', (event) => {
    if (event.key !== 'Enter') return;
    event.preventDefault();
    void searchLeftEmissCatalog();
  });
  controls.leftEmissCatalogIncludeExcluded.addEventListener('change', () => {
    if (controls.indicatorSearch.value.trim() || controls.leftEmissCatalogQuery.value.trim() || state.leftEmissCatalogResults.length) void searchLeftEmissCatalog();
  });
  controls.leftEmissCatalogResults.addEventListener('click', (event) => {
    const button = (event.target as Element).closest<HTMLButtonElement>('[data-left-emiss-catalog-select]');
    const indicatorId = button?.dataset.leftEmissCatalogSelect;
    const item = state.leftEmissCatalogResults.find((candidate) => candidate.indicator_id === indicatorId);
    if (item) void selectLeftEmissCatalogItem(item);
  });
  controls.leftWorldBankCatalogRefresh.addEventListener('click', () => void refreshWorldBankCatalog());
  controls.leftWorldBankCatalogSearch.addEventListener('click', () => void searchWorldBankCatalog());
  controls.leftWorldBankCatalogQuery.addEventListener('keydown', (event) => {
    if (event.key !== 'Enter') return;
    event.preventDefault();
    void searchWorldBankCatalog();
  });
  controls.leftWorldBankCatalogResults.addEventListener('click', (event) => {
    const button = (event.target as Element).closest<HTMLButtonElement>('[data-left-worldbank-catalog-select]');
    const indicatorId = button?.dataset.leftWorldbankCatalogSelect ?? button?.dataset.leftWorldBankCatalogSelect;
    const item = state.worldBankCatalogResults.find((candidate) => candidate.indicator_id === indicatorId);
    if (item) void selectWorldBankCatalogItem(item);
  });
  controls.emissIndicatorId.addEventListener('input', () => {
    clearEmissInspectionState(true);
  });
  controls.emissFilterList.addEventListener('click', (event) => {
    const button = (event.target as Element).closest<HTMLButtonElement>('[data-emiss-filter-search]');
    const card = button?.closest<HTMLElement>('[data-emiss-filter-card]');
    if (button && card) void searchEmissFilterValues(card);
  });

  controls.emissFilterList.addEventListener('keydown', (event) => {
    const input = (event.target as Element).closest<HTMLInputElement>('[data-emiss-filter-search-input]');
    if (!input || event.key !== 'Enter') return;
    event.preventDefault();
    const card = input.closest<HTMLElement>('[data-emiss-filter-card]');
    if (card) void searchEmissFilterValues(card);
  });
}
